import React, { FC, useState } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { usePurchaseRoDetailsModel } from "../scmPurchaseRoModel";
import { ColumnsType } from "antd/es/table";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { ISCMPRoGoodsDetail } from "../scmPurchaseRoType";
import { formatNum } from "@/utils/utils";
import { useScmSaleRoDetailModel } from "../../scmSaleRo/scmSaleRoModel"
import { useVrmPurchaseRoDetailsModel } from "@/views/vrmBill/vrmBillPurchaseRo/vrmBillPurchaseRoModel"

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { getTreeNodeName } = useScmSaleRoDetailModel();
    const { lookGoodsList } = usePurchaseRoDetailsModel();
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const { goToPurchaseDetail } = useVrmPurchaseRoDetailsModel()
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { branch } = detailsInfo
    const columns: ColumnsType<ISCMPRoGoodsDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
        }, {
            title: '已入库数量',//'采购数量',
            width: 100,
            dataIndex: 'purchaseNum',
        }, {
            title: '赠品数量',
            width: 100,
            dataIndex: 'giftsNum',
        }, {
            title: '已退货数量',
            width: 100,
            dataIndex: 'returnedNum',
        }, {
            title: '开单数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 130,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '总计',
            width: 136,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '商品类型',
            width: 120,
            dataIndex: 'typeName',
        }, {
            title: '替换编号',
            width: 130,
            dataIndex: 'replaceCode',
        }, {
            title: '驳回数量',
            width: 100,
            dataIndex: 'rejectNum',
            render: (text: string) => <span className={+text > 0 ? "color-red" : ""}>{text}</span>
        }, {
            title: '确认数量',
            width: 100,
            dataIndex: 'confirmNum',
        }, {
            title: '出库总计',
            width: 136,
            dataIndex: 'stockIoAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '出库员',
            width: 120,
            dataIndex: 'stockIoStaff',
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '单位',
            width: 100,
            dataIndex: 'unitName',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
            render: (t) => <Tooltip placement="topLeft" title={t} arrowPointAtCenter>
                <p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goToPurchaseDetail(t, branch) }}>{t}
                </p></Tooltip>
        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',

        }, {
            title: '采购订单号',
            width: 160,
            dataIndex: 'planCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }
    ];


    return (
        <YhBox title="" style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.key}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMPRoGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                columns={columns}
                dataSource={lookGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}